import { forwardRef, type Ref, type SVGProps } from "react";
const IconNightLifeFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M26.45 7.678c.591-.64.137-1.678-.735-1.678H22.12l1.698-2.426a1 1 0 0 0-1.638-1.147L19.679 6H6.283c-.872 0-1.326 1.038-.735 1.678l9.454 10.242L15 18v8h-4a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2h-4v-8q0-.04-.003-.08zM19.32 10h2.265l1.846-2H20.72zm-1.041-2-1.4 2h-6.466L8.567 8z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconNightLifeFilledSVG);
ForwardRef.displayName = "IconNightLifeFilled";
export { ForwardRef as IconNightLifeFilled };
